import { type TimeRange } from '../../types';

const DEFAULT_VALUE: TimeRange = {
	startHour: 0,
	startMinute: 0,
	endHour: 0,
	endMinute: 0,
};

export { DEFAULT_VALUE };
